module.exports = __webpack_public_path__ + "static/media/covid-19-tracker-thumbnail.4a70395b.png";